/**
 * **Menü „Aufgaben“** in der Menüleiste (#257, nur macOS): was Main und Renderer darüber
 * austauschen. Der Renderer meldet, welche Befehle die aktive Seite gerade kann
 * (`task-menu:state`), das Menü schickt den gewählten zurück (`task-menu:command`).
 */

/** Ein Befehl des Menüs, der an der Auswahl der Seite wirkt. */
export type TaskCommand =
  | 'when'
  | 'deadline'
  | 'duration'
  | 'recurrence'
  | 'tags'
  | 'attention'
  | 'reward'
  | 'complete'
  | 'focus'
  | 'rest'
  | 'favorite'
  | 'details'
  | 'showInProject'
  | 'move'
  | 'duplicate'
  | 'delete'

/** `null` heißt: Die Seite vorn hat keine Aufgabenliste — alles grau außer der Schnelleingabe. */
export interface TaskMenuState {
  /** Was gerade geht. Fehlt ein Befehl, ist sein Eintrag grau. */
  enabled: TaskCommand[]
  /** Die gemeinte Aufgabe ist erledigt — „Wieder öffnen“ statt „Erledigen“. */
  completed: boolean
  /** Sie ruht — „Aufwecken …“ statt „Ruhen lassen“. */
  resting: boolean
  /** Sie ist ein Favorit — „Aus Favoriten entfernen“. */
  favorite: boolean
  /** Die Aufgaben-Details sind offen — „Details ausblenden“. */
  detailsOpen: boolean
}

export const TASK_MENU_STATE_CHANNEL = 'task-menu:state'
export const TASK_MENU_COMMAND_CHANNEL = 'task-menu:command'
